import React from 'react';
import '../../styles/Modal.scss'; // 공통 모달 스타일

interface SessionExpireModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  title?: string;
  message?: string;
  confirmText?: string;
}

const SessionExpireModal: React.FC<SessionExpireModalProps> = ({
  isOpen,
  onConfirm,
  title = "세션 만료",
  message = "세션이 만료되었습니다.\n다시 로그인해 주세요.",
  confirmText = "확인",
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content session-expire-modal">
        <div className="modal-header">
          <h3>{title}</h3>
        </div>
        <div className="modal-body">
          <p style={{ whiteSpace: 'pre-wrap', textAlign: 'center' }}>{message}</p>
        </div>
        <div className="modal-footer one-button">
          <button className="btn-confirm" onClick={onConfirm}>
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SessionExpireModal;